import { IButtonsValueDisp } from "./interfaces/IButtonsValueDisp";
import { AValueComponent } from "./AValueComponent";
import { ValueChangerController } from "./ValueChangerController";

import MouseEvent = createjs.MouseEvent;

export class ButtonsValueComponent extends AValueComponent {
    protected _stepSize: number;
    protected _buttonContainer: IButtonsValueDisp;

    constructor(parent: ValueChangerController, minValue: number, maxValue: number, buttonContainer: IButtonsValueDisp, stepSize: number) {
        super(parent, minValue, maxValue);
        this._buttonContainer = buttonContainer;

        if (this._buttonContainer.getMoreButton()) {
            this._buttonContainer.getMoreButton().addEventListener("click", this.bindFunction(this.moreClicked));
        }

        if (this._buttonContainer.getLessButton()) {
            this._buttonContainer.getLessButton().addEventListener("click", this.bindFunction(this.lessClicked));
        }

        if (this._buttonContainer.getMaxButton()) {
            this._buttonContainer.getMaxButton().addEventListener("click", this.bindFunction(this.maxClicked));
        }

        this._stepSize = stepSize;
    }

    private maxClicked(event: MouseEvent): void {
        this.dispatchUpdateByUserSignal(this.maxValue);
    }

    private lessClicked(event: MouseEvent): void {
        this.dispatchUpdateByUserSignal(this.value - this._stepSize);
    }

    private moreClicked(event: MouseEvent): void {
        this.dispatchUpdateByUserSignal(this.value + this._stepSize);
    }

    public dispose(): void {
        super.dispose();
        if (this._buttonContainer.getMoreButton()) {
            this._buttonContainer.getMoreButton().removeEventListener("click", this.bindFunction(this.moreClicked));
        }
        if (this._buttonContainer.getLessButton()) {
            this._buttonContainer.getLessButton().removeEventListener("click", this.bindFunction(this.lessClicked));
        }
        if (this._buttonContainer.getMaxButton()) {
            this._buttonContainer.getMaxButton().removeEventListener("click", this.bindFunction(this.maxClicked));
        }
    }
}
